export default __webpack_public_path__ + "static/media/white-close.17fd973e.svg";